<div id="top"></div>
<app-publicnavbar></app-publicnavbar>
<br>

<div class="container-fluid" >
  <div class="row">
      <div class="col-md-12">
        
        
          <h1 class="display-6"  style="color: #7d3f98;">Support</h1>
          <hr>
            <div *ngIf="supportPage">
              <div  [innerHTML]="this.products.properties.elements.content.value"></div> 
            </div>
      </div>
  </div>    
</div>

<!--
<div class="container-fluid" >
  <div class="row">
    <div class="col-md-12">
      <div style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block">

        <table role="presentation" width="80%" style="margin: 0px auto;">
            <tr> 
              <td   >
              <h3 class="display-6"  style="color: #7d3f98;">Support</h3>
              <hr>
              <div class="col-md-12 px-0 " style="margin-left:10px;vertical-align: top;">
                
                
                <h4 class="display-6"  style="color: #7d3f98;">Questions</h4>
                  <p>We’re here to help.</p>
                  <p >If you are having an issue related to one of the APIs, please retest your application in the Developer Sandbox to ensure your coding is correct before contacting us. </p>
                  <p >For developer support, please email <a class="aetnaMainDiv" href="mailto:interoperabilitydevelopersupport@aetna.com"><u>Developer Support</u></a>. Remember, do not send member’s personal health information through email. Member specific claims issues or authentication issues (e.g., forgot username or password) will not be resolved through the developer support mailbox.</p>
                  <p >The email to <a   class="aetnaMainDiv" href="mailto:interoperabilitydevelopersupport@aetna.com"><u>Developer Support</u></a> should contain the following information:<p>
                  <ul class="center">
                    <li> A description of the issue</li>
                    <li>The relevant environment: either the Developer Sandbox or one of the production APIs</li>
                    <li>The API: either the Patient Access API or the Provider Directory API</li>
                    <li>The FHIR resource API(s) that you are having an issue with</li>
                    <li>The response code and error message </li>
                    <li>The time, including time zone, and date of the error</li>
                    <li>Your contact information </li>
                  </ul>
              
                  <div>  
                    <div>
                        <br>
                        <h4 class="display-6"  style="color: #7d3f98;">Steps to create an app and subscribe to an API</h4>
                        <hr>
                    </div>
                    <div>
                        <h5 class="display-6"  style="color: #7d3f98; margin-top: 30px;"><strong>Create an Application</strong></h5>
                         <br>
                        <img src="assets/images/page1.png" alt="page1" style=" width: 65%;">
                    </div>
                    <div>
                      <h5 class="display-6"  style="color: #7d3f98; margin-top: 50px;"><strong>Record Client ID/Secret and View Applications</strong></h5>
                      <br>
                      <img src= "assets/images/page2.png" alt="page2" style=" width: 65%;">
                    </div>
                    <div>
                      <h5 class="display-6"  style="color: #7d3f98; margin-top: 50px;"><strong>Subscribe to APIs</strong></h5>
                      <br>
                      <img src= "assets/images/page3.png" alt="page3" style=" width: 65%;"> 
                    </div>
                    <div>
                      <h5 class="display-6"  style="color: #7d3f98; margin-top: 50px;"><strong>Complete/Email Questionnaire and Subscribe to Additional APIs</strong></h5>
                      <br>
                      <img src= "assets/images/page4.png" alt="page4" style=" width: 65%;">
                    </div>
                    <div>
                      <h5 class="display-6"  style="color: #7d3f98;margin-top: 55px; "><strong>Helpful Hints</strong></h5>
                      <br>
                      <div style= " border-width: 5px; border-style: solid; border-color: #7d3f98; width: 65%;">
                        <ul >
                          <li style= " margin-top: 6px;"> Within any application you create, you can view your Client ID, Subscriptions, Update App and View API Products.</li>
                          <li> Updating the app allows you to change your Callback URL, Delete the App, Reset the Client Secret (in case you forgot to write it down) and verify the Client Secret.</li>
                          <li> Verifying the Client Secret can be helpful if you have created multiple apps and cannot remember which client secret applies to which app.</li>
                          <li> For each API that is subscribed, be sure to subscribe to <b> ALL </b>fhir APIs (fhir, fhir-a, fhir-d, etc.) to ensure successful API connection.</li>
                          <li> If you are already approved for sandbox and request access to production APIs, a new questionnaire is not needed. Please allow some time for the access to be approved. </li>
                          <li> If you are already approved for production and request access to sandbox, your access will automatically be approved. </li>
                          <li> Please refrain from deleting all applications and subscriptions in any environment. Doing so will cause any new applications and subscriptions to receive a pending status. Should this happen, <a class="aetnaMainDiv" href="mailto:AetnaInteroperabilityProductionAccess@aetna.com "> <u> email </u> </a> for assistance. </li>
                        </ul>
                      </div>
                    </div>
                  </div>
            </div>
              
              </td>  
          </tr>  
        </table>  
      <br>
      </div>
    </div>
  </div>
</div>     

-->